const burgerMenu = $('.js-burgerMenu')

$('.js-burgerMenuButton').on('click', () => {
  burgerMenu.addClass('burger-menu_is_opened')
})

$('.js-burgerMenuClose').on('click', () => {
  burgerMenu.removeClass('burger-menu_is_opened')
})

$('.js-burgerNavSublistToggle').on('click', (e) => {
  const currentTarget = $(e.currentTarget)
  const sublist = currentTarget.next()

  sublist.slideToggle(200)
})
